// extracted by mini-css-extract-plugin
export default {"limit":"Textarea_limit__MRhE2","textarea":"Textarea_textarea__1vXz0","wrapper":"Textarea_wrapper__XbT27"};